import React, { useEffect, useState } from 'react';
import './index.less';
import {AgriAlertWindSpeedIcon} from '@/resource/IconComponentSets';
import { SpeedUnitEnum } from '@/page/Agrialert/template-management/template-management';
import { IAgriAlertTranslateResModel } from '@/util/Request/agrialert/responseType';

interface IProp{
    speedType: string;
    left?: number;
    translateData?: IAgriAlertTranslateResModel;
}

interface IWindLevelModel{
    NoLevel: number;
    FirstLevel: number;
    SecondLevel: number;
    ThirdLevel: number;
    FourthLevel: number;
}

const TemplateImageLegend = (prop:IProp)=>{

    const {
        speedType,
        translateData,
        left = -10
    } = prop;


    const [speedLevel,setSpeedLevel] = useState<IWindLevelModel>(null);
    const [speedUnitName,setSpeedUnitName] = useState(null);

    useEffect(()=>{
        if(speedType){
            if(speedType === SpeedUnitEnum.BEAUFORT){
                setSpeedUnitName(SpeedUnitEnum.BEAUFORT);
                setSpeedLevel({
                    NoLevel: 0,
                    FirstLevel: 3,
                    SecondLevel: 6,
                    ThirdLevel: 9,
                    FourthLevel: 12
                });
            }
            else if(speedType === SpeedUnitEnum.KMH){
                setSpeedUnitName(SpeedUnitEnum.KMH);
                setSpeedLevel({
                    NoLevel: 0,
                    FirstLevel: 15,
                    SecondLevel: 40,
                    ThirdLevel: 75,
                    FourthLevel: 120
                });
            }
            else if(speedType === SpeedUnitEnum.MPH){
                setSpeedUnitName(SpeedUnitEnum.MPH);
                setSpeedLevel({
                    NoLevel: 0,
                    FirstLevel: 10,
                    SecondLevel: 25,
                    ThirdLevel: 45,
                    FourthLevel: 75
                });
            }
        }
    },[speedType]);

    return(
        <div className='image-legend-container'
            style={{left:`${-left}px`, width: `${822 + left}px`}}
        >
            {/* Speed legend*/}
            <div className='speed-container'>
                <div className='speed-item'>
                    <div className='lenged-title'>
                        {speedLevel && speedLevel.NoLevel}
                    </div>
                    <div className='lenged-title' style={{fontSize:'8px',paddingLeft:'4px'}}>
                        {(translateData && translateData?.no_wind) || 'No Wind'}
                    </div>
                </div>
                <div className='speed-item'>
                    <div className='lenged-title'>
                        {speedLevel && speedLevel.FirstLevel}
                    </div>
                    <div>
                        <AgriAlertWindSpeedIcon
                            width = {20}
                            height = {12}
                            className={'rotate-90'}
                        />
                    </div>
                </div>
                <div className='speed-item'>
                    <div className='lenged-title'>
                        {speedLevel && speedLevel.SecondLevel}
                    </div>
                    <div>
                        <AgriAlertWindSpeedIcon
                            width = {20}
                            height = {16}
                            className={'rotate-90'}
                        />
                    </div>
                </div>
                <div className='speed-item'>
                    <div className='lenged-title'>
                        {speedLevel && speedLevel.ThirdLevel}
                    </div>
                    <div>
                        <AgriAlertWindSpeedIcon
                            width = {20}
                            height = {20}
                            className={'rotate-90'}
                        />
                    </div>
                </div>
                <div className='speed-item'>
                    <div className='lenged-title'>
                        {speedLevel && speedLevel.FourthLevel}
                    </div>
                    <div>
                        <AgriAlertWindSpeedIcon
                            width = {24}
                            height = {24}
                            className={'rotate-90'}
                        />
                    </div>

                </div>
                <div className='speed-item'>
                    <div></div>
                    <div className='lenged-title'>
                        {(translateData && translateData.storm) || 'Storm'}
                    </div>
                </div>
                <div className='speed-item'>
                    <div></div>
                    <div className='lenged-title'>{speedUnitName}</div>
                </div>
            </div>
            {/* Direction legend */}
            <div className='direction-container'>
                <div className='direction-item'></div>
                <div className='direction-item lenged-title'>N</div>
                <div className='direction-item'></div>
                <div className='direction-item lenged-title'>W</div>
                <div className='direction-item'>
                    <AgriAlertWindSpeedIcon
                        width = {16}
                        height = {16}
                        className={'rotate-45'}
                    />
                </div>
                <div className='direction-item lenged-title'>E</div>
                <div className='direction-item'></div>
                <div className='direction-item lenged-title'>S</div>
                <div className='direction-item'></div>
            </div>
        </div>
    );
};

export default React.memo(TemplateImageLegend);